import React from "react";
import { useFeatureFlagEnabled } from "posthog-js/react";
import { FeatureToggle } from "shared/src/constants/featureToggleNames";
import ClaimableAuthenticatorV2 from "../ClaimableAuthenticatorV2";
import ClaimableAuthenticator from "../ClaimableAuthenticator";
import PageLoader from "../PageLoader";

export interface AuthFlowWrapperProps {
  children: React.ReactNode;
  defaultTab?: "signUp" | "signIn";
  hideSignUp?: boolean;
  prefilledEmail?: string;
  formFields?: Record<string, unknown>;
  onLoginComplete?: () => void;
}

export function AuthFlowWrapper({
  children,
  defaultTab,
  hideSignUp,
  prefilledEmail,
  formFields,
  onLoginComplete,
}: AuthFlowWrapperProps) {
  const featureFlagValue = useFeatureFlagEnabled(FeatureToggle.AUTH_FLOW_V2);
  const isLoading = featureFlagValue === undefined;
  const isV2 = featureFlagValue === true;

  if (isLoading) {
    return <PageLoader />;
  }

  if (isV2) {
    return (
      <ClaimableAuthenticatorV2
        defaultTab={defaultTab}
        hideSignUp={hideSignUp}
        prefilledEmail={prefilledEmail}
        onLoginComplete={onLoginComplete}
      >
        {children}
      </ClaimableAuthenticatorV2>
    );
  }

  return (
    <ClaimableAuthenticator
      defaultTab={defaultTab}
      hideSignUp={hideSignUp}
      formFields={formFields}
      onLoginComplete={onLoginComplete}
    >
      {children}
    </ClaimableAuthenticator>
  );
}
